import CategoryExploration from './categoryExploration'

export default CategoryExploration
